<template>
  <div class="rounded-md bg-white p-6 shadow-md">
    <div class="space-y-4">
      <div
        class="w-fit rounded-md border border-blue-300 bg-blue-50 px-4 py-2 text-blue-700 shadow-md"
      >
        <p class="flex items-center space-x-2 font-medium">
          <SolidInformationCircleIcon class="h-6 w-6 shrink-0 fill-current" />
          <span>Consideraciones</span>
        </p>
        <div class="ml-5">
          <ul class="list-disc">
            <li>
              Mediante esta aplicación no se realizará ningún reembolso, solamente se marcarán como
              devueltos los comprobantes.
            </li>
            <li>
              Sólo se pueden marcar como devueltos aquellos comprobantes que estén pagos y no se
              encuentren usados (asociados a una factura de América).
              <!-- Por lo tanto, la búsqueda por factura es meramente informativa. -->
            </li>
          </ul>
        </div>
      </div>
      <!-- <h4 class="md:col-span-2 text-lg font-medium">Buscar por:</h4>
      <div class="flex flex-wrap gap-x-6 gap-y-2">
        <div class="flex items-center space-x-2">
          <input
            v-model="componenteBusqueda"
            value="DevolucionPorComprobante"
            type="radio" name="componenteBusqueda" id="radio-comprobante"
            class="w-4 h-4 transition duration-150 ease-in-out border-gray-400 rounded-full text-colescba-blue-600 focus:ring-colescba-blue-500"
          >
          <label for="radio-comprobante">Búsqueda por comprobante</label>
        </div>
        <div class="flex items-center space-x-2">
          <input
            v-model="componenteBusqueda"
            value="DevolucionPorFactura"
            type="radio" name="componenteBusqueda" id="radio-factura"
            class="w-4 h-4 transition duration-150 ease-in-out border-gray-400 rounded-full text-colescba-blue-600 focus:ring-colescba-blue-500"
          >
          <label for="radio-factura">Búsqueda por factura de América</label>
        </div>
      </div> -->
      <transition
        enter-active-class="transition-opacity duration-200"
        leave-active-class="transition-opacity duration-200"
        enter-class="opacity-0"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <component :is="componenteBusqueda" />
      </transition>
    </div>
  </div>
</template>

<script>
import { useSession, useAcreditacionServicio } from '@colescba/ui'
import { useAccessControl } from '@/composables'

import DevolucionPorComprobante from '@/components/DevolucionComprobantes/DevolucionPorComprobante'
import DevolucionPorFactura from '@/components/DevolucionComprobantes/DevolucionPorFactura'

export default {
  name: 'Devoluciones',

  components: { DevolucionPorComprobante, DevolucionPorFactura },

  mixins: [useSession(), useAcreditacionServicio(), useAccessControl()],

  data() {
    return {
      componenteBusqueda: 'DevolucionPorComprobante',
    }
  },
}
</script>
